<script>
export default {
  name: 'BreadcrumpAdmin',
  props: {
    firstItems: {
      type: Object,
      required: false
    },
    secondItems: {
      type: Object,
      required: false
    }
  }
}
</script>

<template>
  <nav class="flex mb-5" aria-label="Breadcrumb">
    <ol class="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
      <li class="inline-flex items-center">
        <router-link :to="{name: 'app_profil'}" class="inline-flex items-center text-sm font-medium text-gray-700 hover:text-primary-700">
          <i class="fa-solid fa-house mr-2"></i>
          Dashboard
        </router-link>
      </li>
      <li v-if="firstItems">
        <div class="flex items-center">
          <svg class="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 9 4-4-4-4"/>
          </svg>
          <router-link :to="{name: firstItems.url}" class="ms-1 text-sm font-medium text-gray-700 hover:text-primary-700 md:ms-2">
            {{ firstItems.text }}
          </router-link>
        </div>
      </li>
      <li v-if="secondItems" aria-current="page">
        <div class="flex items-center">
          <svg class="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 9 4-4-4-4"/>
          </svg>
          <span class="ms-1 text-sm font-medium text-gray-500 md:ms-2">
            {{ secondItems.text }}
          </span>
        </div>
      </li>
    </ol>
  </nav>
</template>
